/**
 * OneDial Africa — wallet client.
 *
 * Thin axios wrapper for customer wallet + payment endpoints. Re-uses the
 * existing customer auth cookies (withCredentials).
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const walletApi = axios.create({ baseURL: API, withCredentials: true });

export function gbp(amount) {
  if (amount == null || Number.isNaN(amount)) return "£0.00";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(amount);
}

export function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return String(iso);
  }
}
